import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question:
      "What are Some Common Programming Languages Used in Game Development?",
    answer: `<p>The leading programming languages in game development provide flexible solutions for crafting dynamic gaming adventures. Key languages such as C++, C#, and Python are known for their efficiency and compatibility with game engines. Meanwhile, Java and JavaScript stand out for their wide use in developing web-based gaming applications.</p>`,
  },
  {
    question: "How Long Does Game Development Take Time?",
    answer: `<p>Although, the game concept requires approval from the publisher, who reserves the right to reject specific titles. Meanwhile, contemporary PC or console games typically take between three to five years to finalize. On the other hand, mobile games are usually developed within a matter of months.</p>`,
  },
  {
    question: "Why is Game Development so Expensive in Saudi Arabia?",
    answer: `<p>Saudi Arabia's significant $37.8 billion investment to become a gaming industry hub offers both opportunities and challenges. Local game companies need help with funding, finding talent, and high living costs, while also needing help attracting international talent. Individual developers also face challenges like securing funds, marketing, and balancing other commitments. Moreover, developers want more support to strengthen the gaming scene in the Kingdom.:</p>`,
  },
  {
    question: "What is the Best Software for Game Development?",
    answer: `<p>Here's the list of the 10 best game design & development software to use in 2024:</p>
       <ul>
       <li>ClickUp</li>
       <li>Construct 3</li>
       <li>GameSalad</li>
       <li>Blender</li>
       <li>Godot</li>
       <li>Unreal Engine</li>
       <li>GameMaker</li>
       <li>Unity</li>
       <li>Allegro</li>
       <li>Wwise</li>
       </ul>`,
  },
  {
    question:
      "What is the Difference Between Game Design and Game Development?",
    answer: `<p>A video game designer is responsible for the creative aspects, defining the game's aesthetics and overall vision. Meanwhile, game developers focus on the technical implementation, comprehending the designer's vision into reality through coding and technical execution.</p> `,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
          {/* <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{DubaiPin}</div>
          </Col> */}
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
